import * as R from "ramda";
import Layout from "./Layout";
import { createContext } from "redux-mvc";
import module from "../index";
import { selectFeatureFlag } from "redux/modules/lenndFlags";
import * as flags from "utils/feature-flags";
import { connect } from "react-redux";

const mapStateToProps = state => ({
  isSuperAdmin: selectFeatureFlag(flags.IS_SUPER_ADMIN.NAME)(state)
});

const decorate = R.compose(
  connect(mapStateToProps),
  createContext({
    module,
    options: {
      observedDomains: ["user", "event", "permissions", "organization"],
      dispatchToGlobal: R.compose(
        R.not,
        R.test(new RegExp(R.join("|", module.modules))),
        R.prop("type")
      ),
      persist: false
    }
  })
);

export default decorate(Layout);
